import {Box, Checkbox, FormControlLabel, Grid, IconButton, TextField, Tooltip, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {CalendarMonth} from "@mui/icons-material";
import {LoadingButton} from "@mui/lab";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import {getPersonTodos, markTodoDone} from "../../../../API/clientRetention";
import {selectors as opportunitySelectors} from "../../../../Ducks/opportunity";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import PersonTodoList from "../../ClientRetention/PersonTodoList";
import moment from "moment";


export function TodoActionHistoryNoteTextInput(props) {
    const {participantTodoId, action, handleHistoryNoteTextInputCallback, readOnly} = props;
    const [text, setText] = useState('');
    const [responseText, setResponseText] = useState('');

    useEffect(() => {
        const {response} = action;
        const responseFound = response?.find((item) => item.action_id === action.id);

        if (responseFound) {
            setResponseText(responseFound.response);
        }

    }, [action]);

    return (
        <Grid item sx={{padding: '15px', marginLeft: '30px'}}>
            {
                responseText || readOnly ?
                    <div><i sx={{fontSize: 'smaller', pr: 10}}>History Note: </i>{responseText}
                    </div> :
                    <Grid container>
                        <Grid item xs={3}>
                            <Box sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                            }}>
                                <Typography variant='subtitle1' component='div'
                                            sx={{fontSize: 'smaller', margin: '0 auto'}}>
                                    History Note:
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={8}>
                            <TextField
                                name='text'
                                multiline
                                rows={4}
                                variant="outlined"
                                fullWidth
                                size='small'
                                onChange={(event) => setText(event.target.value)}
                            />
                        </Grid>
                        <Grid xs={1} sx={{marginTop: '10px', textAlign: 'right'}}>
                            <LoadingButton
                                variant='outlined'
                                onClick={() => handleHistoryNoteTextInputCallback(participantTodoId, action, text)}
                                sx={{marginLeft: '10px', padding: '3px'}}>Save</LoadingButton>
                        </Grid>
                    </Grid>
            }
        </Grid>
    );
}

export function TodoActionSingleRadioGroup(props) {
    const {participantTodoId, action, handleSingleRadioClickCallback, readOnly} = props;
    const [responseYesOrNo, setResponseYesOrNo] = useState('');

    useEffect(() => {
        if (action?.response) {
            let response = action.response.find((item) => item.action_id === action.id)?.response;
            setResponseYesOrNo(response);
        }
    }, [action]);
    return (
        <Grid item sx={{padding: '10px', marginLeft: '30px', display: 'flex'}}>
            <RadioGroup
                row
                size="small"
                aria-labelledby='todo-overview-single-radio-buttons-group-label'
                name='yes-no'
                onChange={(event) => {
                    setResponseYesOrNo(event.target.value);
                }}>
                <FormControlLabel
                    value='Yes'
                    control={<Radio checked={responseYesOrNo === 'Yes'}/>}
                    label='Yes'
                    disabled={readOnly}/>
                <FormControlLabel
                    value='No'
                    control={<Radio checked={responseYesOrNo === 'No'}/>}
                    label='No'
                    disabled={readOnly}/>
            </RadioGroup>
            {!readOnly &&
                <LoadingButton
                    variant='outlined'
                    onClick={() => handleSingleRadioClickCallback(participantTodoId, action, responseYesOrNo)}
                    sx={{marginLeft: '10px', padding: '3px'}}>Save</LoadingButton>}
        </Grid>
    )
}

export function TodoActionMultiRadioGroup(props) {
    const {action, participantTodoId, handleMultiRadioClickCallback, readOnly} = props;
    const [selected, setSelected] = useState('');
    const [responseOption, setResponseOption] = useState([]);

    useEffect(() => {
        const {response} = action;
        const responseFound = response.find((item) => item.action_id === action.id);

        if (responseFound) {
            setResponseOption(responseFound.response);
        }

    }, [action]);

    return (

        <Grid container>
            <Grid item xs={3} sx={{padding: '15px', marginLeft: '30px', display: 'flex'}}>
                <RadioGroup
                    row
                    size="small"
                    aria-labelledby='todo-overview-multi-radio-buttons-group-label'
                    name={action.options[0].key}
                    onChange={(e) => {
                        const {value} = e.target;
                        setSelected(value);
                    }}>
                    {
                        action.options.map((option, index) => (
                            <FormControlLabel
                                key={index}
                                name={option.key}
                                value={option.value}
                                control={<Radio
                                    checked={(responseOption.length > 0 && responseOption === option.value) || selected === option.value}/>}
                                label={option.value}
                                disabled={action?.completed || readOnly}/>
                        ))
                    }
                </RadioGroup>
            </Grid>
            <Grid xs={1} sx={{marginTop: '10px', textAlign: 'right'}}>
                {
                    !action?.completed && !readOnly &&
                    <LoadingButton
                        variant='outlined'
                        onClick={() => handleMultiRadioClickCallback(participantTodoId, action, selected)}
                        sx={{marginLeft: '10px', padding: '3px'}}>Save</LoadingButton>
                }
            </Grid>
        </Grid>
    )
}

export function TodoActionShowText(props) {
    const {todo} = props;

    return (
        <Grid item sx={{padding: '15px', marginLeft: '30px'}}>
            <div><i sx={{fontSize: 'smaller', pr: 10}}>Description: </i>{todo.description}
            </div>
        </Grid>
    )
}

export function TodoActionCheckbox(props) {
    const {participantTodoId, action, handleCheckboxChangeCallback, readOnly} = props;
    const [selected, setSelected] = useState([]);
    const [responseOptions, setResponseOptions] = useState([]);

    useEffect(() => {
        const {response} = action;
        const responseFound = response.find((item) => item.action_id === action.id);

        if (responseFound) {
            setResponseOptions(responseFound.response);
        }

    }, [action]);

    return (
        <Grid item xs={12} sx={{padding: '15px', marginLeft: '30px'}}>
            <Grid container alignItems="center">
                {
                    action?.options.map((option) => (
                        <Grid item xs={4} sx={{margin: '0px'}}>
                            <FormControlLabel
                                control={<Checkbox color="primary"
                                                   checked={responseOptions?.length > 0 ? responseOptions.some((item) => item.key === option.key) :
                                                       selected?.some((item) => item.key === option.key)} // ✅ Check if value exists
                                />}
                                label={option.value}
                                name={option.key}
                                labelPlacement="end"  // Positions label to the right of the checkbox
                                disabled={action.completed || readOnly}
                                onChange={(event) => {
                                    const {name, checked} = event.target;
                                    let prevSelected = [...selected];
                                    let nameFound = false;
                                    let selectedOption = action.options.find((option) => option.key === name);
                                    prevSelected.forEach((option, index) => {
                                        if (option.key === name) {
                                            option.checked = checked;
                                            nameFound = true;
                                            if (!checked) {
                                                prevSelected.splice(index, 1);
                                            }
                                        }
                                    });

                                    if (!nameFound) {
                                        setSelected([...prevSelected, selectedOption]);
                                    } else {
                                        setSelected(prevSelected);
                                    }
                                }}
                            />
                        </Grid>
                    ))
                }
            </Grid>
            {
                !action.completed && <LoadingButton
                    variant='outlined'
                    onClick={() => handleCheckboxChangeCallback(participantTodoId, action, selected)}
                    sx={{padding: '3px'}} disabled={readOnly}>Save</LoadingButton>
            }
        </Grid>
    );
}

export function TodoActionPhoneMeeting(props) {
    const {todo, action, handlePhoneMeetingClickCallback, readOnly} = props;
    const [responseText, setResponseText] = useState('');

    useEffect(() => {
        const {response} = action;
        const responseFound = response.find((item) => item.action_id === action.id);

        if (responseFound) {
            setResponseText(responseFound.response);
        }

    }, [action]);
    return (
        <Grid item xs={12} sx={{padding: '15px', marginLeft: '30px'}}>
            {
                responseText ?
                    <div style={{fontSize: 'smaller', pr: 10}}><i>Call scheduled
                                                                  on: </i>{moment(responseText).format('DD/MM/YYYY HH:mm')}
                    </div> :
                    <Tooltip title='Schedule a followup call' placement='top'>
                        <IconButton onClick={() => {
                            handlePhoneMeetingClickCallback(todo, action)
                        }} sx={{fontSize: 11}} disabled={readOnly}>
                            <CalendarMonth color='primary'/> Plan a call
                        </IconButton>
                    </Tooltip>
            }
        </Grid>
    )
}

const TodoOverviewTab = (props) => {
    const {person, events, opportunity} = props;
    const [refreshTodos, setRefreshTodos] = useState(false);
    const [jobEmail, setJobEmail] = useState(null);

    const [personTodos, setPersonTodos] = useState([]);

    useEffect(() => {
        fetchTodos();
    }, [person?.person_id]);

    useEffect(() => {
        if (refreshTodos) {
            fetchTodos();
        }
    }, [refreshTodos]);

    const fetchTodos = () => {
        if (person) {
            getPersonTodos(person.person_id, 1).then((res) => {
                if (res?.data) {
                    setPersonTodos(res.data.data);
                }
                setRefreshTodos(false);
            });
        }
    }

    const markDone = (participantTodoId, payload) => {
        markTodoDone(participantTodoId, payload).then((res) => {
            setRefreshTodos(true);
        });
    }

    useEffect(() => {
        if (opportunity) {
            const _eventToUpdate = events?.filter(e => e.event_id?.split('__').length === 2 && e.event_id?.split('__')[1] == opportunity.opportunity_id)
                .sort((a, b) => new Date(b.created) - new Date(a.created)).at(0);

            const _jobEmail = Object.values(opportunity.related_objects.jobs).filter(item => item.job_is_primary == 1);
            setJobEmail(_jobEmail);
        }
    }, [opportunity, events]);

    return (
        <>
            <Grid container>
                <Grid item xs={9}>
                    <Typography
                        variant='span'
                        component='span'
                        sx={{fontWeight: 'bold'}}>
                        Todo Items
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography
                        variant='span'
                        component='span'
                        sx={{fontWeight: 'bold'}}>
                        Due Date
                    </Typography>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12}>
                    <PersonTodoList todos={personTodos} type='active'
                                    markDoneCallback={markDone}
                                    person={person}
                                    jobEmail={jobEmail}/>
                </Grid>
            </Grid>
        </>

    )
}

const mapStateToProps = (state) => ({
    events: opportunitySelectors.events(state),
    opportunity: opportunitySelectors.opportunity(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TodoOverviewTab);